export enum OhHang {
  NULL,
  MOK,
  HWA,
  TO,
  GEUM,
  SOO,
}
